import { Icons } from '@cockpitai/components/atoms'
import { Typography } from '@cockpitai/components/atoms/Typography'
import { routesPath } from '@cockpitai/constants/routesPath'
import { isMobile } from '@cockpitai/utils/device'
import { useMemo } from 'react'
import { NavLink } from 'react-router-dom'
import { twMerge } from 'tailwind-merge'
import { useSideBar } from '../../SideBarContext'

type LogoProps = {
  isLockedSideBar: boolean
  toggleSideBarLocked: () => void
  resetChat: () => void
}

export function Logo({
  isLockedSideBar,
  toggleSideBarLocked,
  resetChat,
}: LogoProps) {
  const isMobileDevice = useMemo(() => isMobile(), [])

  const { setSidebarIsOpen, sidebarIsOpen } = useSideBar()

  const handleCloseSideBar = () => {
    setSidebarIsOpen(false)
  }

  return (
    <div className={twMerge('logo flex justify-between')}>
      <NavLink
        to={routesPath.dashboard.home}
        onClick={resetChat}
        className="flex gap-2">
        {import.meta.env.VITE_CONSULTANT === 'true' ? (
          <Icons.ConsultaAIGray
            width={35}
            height={35}
          />
        ) : (
          <Icons.SantanderRounded
            width={isLockedSideBar || sidebarIsOpen || isMobileDevice ? 40 : 36}
            height={isLockedSideBar || sidebarIsOpen || isMobileDevice ? 40 : 36}
          />
        )}

        <Typography className="leading-5 text-white flex items-center" weight="light">
          {import.meta.env.VITE_CONSULTANT === 'true' ? 'ConsultaAI' : 'ChamaAI'}
        </Typography>
      </NavLink>

      {!isMobileDevice ? (
        <div className="ml-5 hidden 1lg:flex">
          {isLockedSideBar ? (
            <Icons.Pin
              width={18}
              height={18}
              className="lock-button"
              onClick={toggleSideBarLocked}
              style={{ stroke: 'white' }}
            />
          ) : (
            <Icons.PinOff
              width={18}
              height={18}
              className="lock-button"
              onClick={toggleSideBarLocked}
            />
          )}
        </div>
      ) : (
        <button className="mr-2" onClick={handleCloseSideBar}>
          <Icons.Hamburger className="text-white" />
        </button>
      )}
    </div>
  )
}
